export default __webpack_public_path__ + "static/img-media-yahoo-462b27cbbc6ca5492b61ce2e157ecfc7.jpg";